import { dispatchPromise } from './action-helpers';

export const subscribe = (association, association_id) => {
    return dispatchPromise({
        type: 'SUBSCRIBE_REQUESTED',
        payload: {
            association,
            association_id
        }
    });
}

export const unsubscribe = (association, association_id) => {
    return dispatchPromise({
        type: 'UNSUBSCRIBE_REQUESTED',
        payload: {
            association,
            association_id
        }
    });
}
